import { Fragment, useState, useContext, useEffect } from "react";
import { useSelector } from "react-redux";
import { RootState } from "bodycodi/cmap/app/redux/store";

// context
import { DispatchContext } from "bodycodi/cmap/app/components/common/context";

// comonents
import RollingDateSelectPop from "../../common/RollingDateSelectPop";
import ServiceDetails from "./ServiceDetails";
import ConfirmPopup from "./ConfirmPopup";

// assets
import downBlack from "bodycodi/cmap/app/svg/icon_down_black.svg";

// utils
import { callApi, getUseEndDate, moneyFormatter, recoverTag } from "bodycodi/cmap/app/js/common";

const initialDatePickerValues = {
  seqService: "",
  usePeriod: "",
  usePeriodType: "",
  propDate: "",
};

const PassDetails = ({ passDetails, packageInfo, handlePageClose }: any) => {
  const { seqPartner, seqPartnerBranch, seqPartnerCoach } = useSelector(
    (state: RootState) => state.partner
  );
  const { dispatch } = useContext(DispatchContext);
  const [selectedDates, setSelectedDates] = useState<any>({});
  const [discount, setDiscount] = useState<any>(0);
  const [datePicker, setDatePicker] = useState<any>(initialDatePickerValues);
  const serviceList = passDetails.packagePass === "Y" ? packageInfo.passList : [passDetails];

  const resetDatePicker = () => setDatePicker(initialDatePickerValues);

  const handleOpen = (seqService: number, usePeriod: number, usePeriodType: "M" | "D") => {
    setDatePicker({
      seqService,
      usePeriod,
      usePeriodType,
      propDate: selectedDates[seqService]?.startDate,
    });

    dispatch({
      type: "POP_UP_OPEN",
      id: "NOTIFICATION_POP",
      open: { rollingDateSelectPop: true },
    });
  };

  const toggleConfirmPopup = (open: boolean) => {
    dispatch({
      type: "POP_UP_OPEN",
      id: "REQUEST_APP_PAYMENT_CONFIRM_POP",
      open: { requestAppPaymentConfirmPop: open },
    });
  };

  const handleDateChange = (date: string) => {
    setSelectedDates({
      ...selectedDates,
      [datePicker.seqService]: {
        startDate: date,
        endDate: getUseEndDate(date, datePicker.usePeriod, datePicker.usePeriodType),
      },
    });
    resetDatePicker();
  };

  const handleSubmit = () => {
    callApi(`/send/payment/limit/${seqPartner}`, {}, "GET").then((res) => {
      if (res.remainPayableAmount < 0) {
        dispatch({
          type: "ALERT_SETTING",
          data: {
            alert: true,
            cancleYn: false,
            header: "결제 한도 초과",
            body: `연간 비페이 결제 한도를 초과해서 \n결제 요청을 할 수 없습니다. \n센터 관리자에게 문의해 주세요!`,
            closeAlert: () => {
              toggleConfirmPopup(false);
              handlePageClose();
            },
          },
        });
      } else {
        dispatch({ type: "LOADING_START" });
        const dates = Object.keys(selectedDates).map((key: any) => {
          return {
            seqService: key,
            useStartDate: selectedDates[key]?.startDate,
            useEndDate: selectedDates[key]?.endDate,
          };
        });
        callApi(
          "/send/payment",
          {
            orderPasses: dates,
            seqPricing: passDetails?.seqPricing,
            seqPartnerCoach,
            seqMember: passDetails?.seqMember,
            seqPartner,
            seqPartnerBranch,
            discountAmount: discount || 0,
            paymentAmount:
              passDetails?.packagePass === "Y"
                ? packageInfo?.packagePrice - discount
                : passDetails?.price - discount,
          },
          "POST"
        )
          .then((res) => {
            if (!res.MsgVO) {
              toggleConfirmPopup(false);
              handlePageClose();
              setTimeout(() => {
                dispatch({
                  type: "UPDATE",
                  data: { toast1: true, toastText: "이용권 앱 결제 요청하였습니다." },
                });
              }, 100);
            } else {
              let message = "";
              switch (res.MsgVO?.msgCd) {
                case "AP00001":
                  message = `구매하는 이용권 상품이 \n존재하지 않습니다.`;
                  break;
                case "AP00002":
                  message = `구매한 이용권 주문 정보가 \n존재하지 않습니다.`;
                  break;
                case "AP00004":
                  message = `결제 금액은 100원을 \n넘어야 합니다.`;
                  break;
              }
              dispatch({
                type: "ALERT_SETTING",
                data: {
                  alert: true,
                  cancleYn: false,
                  header: "이용권 안내",
                  body: `${message} \n바디코디 회원관리프로그램에서 \n이용권을 다시 확인해 주세요!`,
                  closeAlert: () => {
                    toggleConfirmPopup(false);
                    handlePageClose();
                    return;
                  },
                },
              });
            }
          })
          .finally(() => {
            dispatch({ type: "LOADING_END" });
          });
      }
    });
  };

  // Get default dates for date picker
  useEffect(() => {
    let dates: any = {};
    serviceList.map((service: any) => {
      const today = new Date();
      dates[service.seqService] = {
        startDate: today.format(),
        endDate: getUseEndDate(today.format(), service.usePeriod, service.usePeriodType),
      };
    });
    setSelectedDates(dates);
  }, []);

  return (
    <div className="popup-body request-app-payment">
      {passDetails?.packagePass === "Y" && ( // if pass is package type
        <div className="package-info">
          <div>
            <span className="badge">패키지</span>
            <span className="title">{recoverTag(packageInfo?.pricingName)}</span>
          </div>
          <span className="service-names">{packageInfo?.serviceNames.join(" + ")}</span>
          <span className="price">{moneyFormatter(packageInfo?.packagePrice)}</span>
        </div>
      )}
      {serviceList?.map((service: any, index: number) => {
        return (
          <Fragment key={index}>
            <ServiceDetails service={service} />
            <div className="date-select-container">
              <div>
                <span className="label">시작일</span>
                <div
                  className="date-select"
                  onClick={() =>
                    handleOpen(service.seqService, service.usePeriod, service.usePeriodType)
                  }
                >
                  <span>{selectedDates[service?.seqService]?.startDate}</span>
                  <img src={downBlack} />
                </div>
              </div>

              <div>
                <span className="label">종료일</span>
                <div className="date-select">
                  <span className="gray">{selectedDates[service?.seqService]?.endDate}</span>
                </div>
              </div>
            </div>
            {index < serviceList.length - 1 && <div className="divider" />}
          </Fragment>
        );
      })}

      <div className="footer">
        <button className="confirm" onClick={() => toggleConfirmPopup(true)}>
          다음
        </button>
      </div>

      <RollingDateSelectPop
        mode="days"
        activeMode="black"
        propDate={datePicker.propDate}
        onChange={(date: any) => handleDateChange(date)}
      />
      <ConfirmPopup
        passDetails={passDetails}
        packageInfo={packageInfo}
        selectedDates={selectedDates}
        discount={discount}
        onDiscountChange={(val: any) => setDiscount(val)}
        handleSubmit={handleSubmit}
      />
    </div>
  );
};

export default PassDetails;
